import {
  slab, wallZ, wallX, goal, sign, neon, checkpoint, edgeLights,
  gravfield, wind, speedgate,
} from '../kit.js';

/**
 * Compound sector: the current married to the shelf. Chapter one pays a
 * speed gate's toll by gliding a jetstream (friction eats wind on the
 * ground, so leaving it IS the mechanic). Chapter two fires the classic pit
 * fling through a crosswind that bends the flight onto an offset deck.
 * Chapter three rides a jetstream home.
 */
export default {
  id: 'slipstream',
  name: 'SLIPSTREAM',
  blurb: 'Stay airborne. The current only owns the air.',
  mode: { type: 'sprint', par: 60 },
  redline: { seconds: 39 },   // docs/REDLINE.md; seeded from the board, honesty pass pending
  spawn: { p: [0, 0.4, 8], yaw: 0 },
  killY: -150,
  env: {
    fog: 0x101a26,
    fogDensity: 0.0040,
    sky: { zenith: 0x050c16, horizon: 0x14304a, glow: 0x3a9ad8, aurora: 0xbfe9ff },
    floorY: -280,
  },
  objects: [
    // ============ chapter one: glide the corridor, pay the toll ============
    slab(0, 0, 0, 24, 20, 'plate', 1.4),
    ...edgeLights(0, 0, 0, 24, 20, 'cyan'),
    checkpoint(0, 0, 6),
    sign(0, 3.2, 5, 0, ['SLIPSTREAM', 'THE CURRENT ONLY OWNS THE AIR', 'JUMP IN. IT PAYS THE TOLL.'], '#bfe9ff'),

    // One long jetstream glide with the toll gate hanging mid-air in the
    // current: hop off the edge, the stream accelerates you past 30 by the
    // gate, the far deck catches the descent. The cap is 34 because a
    // current capped at 26 can never pay a 30 toll, and hop-precision
    // platforms at that speed failed the zero-skill bar.
    gravfield(0, -14, -45, 22, 24, 74),
    wind(0, -14, -45, 20, 24, 72, [0, 0, -1], 20, 34),
    speedgate(0, -2, -60, 26, 18, 30),
    slab(0, -12, -94, 26, 28, 'plate', 1.4),
    ...edgeLights(0, -12, -94, 26, 28, 'amber'),
    checkpoint(0, -12, -86),
    sign(0, -8.8, -87, 0, ['PORTAL THE PIT', 'THE WALL FACES THE COURSE', 'THE CROSSWIND BENDS THE FLIGHT'], '#ffb020'),

    // ============ chapter two: the bent fling ============
    // Pit tucked under the deck lip; exit wall fires down-course; a
    // crosswind shoves the flight sideways onto the offset landing.
    wallZ(0, -58, -105.25, 20, 46, 'plate', 1.5),
    wallZ(0, -58, -129.75, 20, 34, 'plate', 1.5),
    wallX(-10.25, -58, -117, 24, 46, 'plate', 1.5),
    wallX(10.25, -58, -117, 24, 46, 'plate', 1.5),
    slab(0, -58, -116.5, 18, 24, 'panel', 1.5),
    neon(0, -57.4, -116.5, [16, 0.14, 0.14], 'magenta'),
    wallZ(0, -12, -100, 15, 12, 'panel', 1.4),
    neon(0, 0.4, -100.7, [15, 0.14, 0.14], 'cyan'),

    // The flight: ~45 m/s out of the wall, ~2.2s to the landing deck, which
    // means ~50m of drop; the deck sits at -60 because arithmetic says so.
    // Starts past the pit mouth: a crosswind that reaches the drop shoves
    // the fall off its own portal before the fling begins.
    wind(8, -32, -151, 34, 36, 58, [1, 0, 0], 22, 18),
    slab(14, -60, -198, 38, 40, 'plate', 1.4),
    ...edgeLights(14, -60, -198, 38, 40, 'lime'),
    checkpoint(14, -60, -190),
    sign(14, -56.8, -191, 0, ['RIDE THE STREAM HOME'], '#9adfff'),

    // ============ chapter three: jetstream home ============
    // Field tops reach ABOVE the deck (the aurora law): a hop apex that
    // clears the field's ceiling misses the gentle gravity and full-g
    // falls through the floor of it.
    gravfield(14, -104, -232, 26, 56, 48),
    wind(14, -104, -232, 24, 56, 46, [0, -0.12, -0.99], 20, 26),
    slab(14, -100, -274, 32, 32, 'plate', 1.6),
    ...edgeLights(14, -100, -274, 32, 32, 'cyan'),
    checkpoint(14, -100, -266),
    goal(14, -100, -280, 0),
  ],
};
